import React from 'react';
import { hydrateRoot } from 'react-dom/client';
import App from './App.jsx';
import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';

import './assets/css/skeleton.css';
import './assets/css/bootstrap.min.css';
import './assets/css/stellarnav.css';
import 'react-toastify/dist/ReactToastify.css';
import './assets/css/style.css';
import './styles/testimonials.css';
import './assets/css/responsive.css';

// Get the root element
const rootElement = document.getElementById('root');

// Get initial state from window.__INITIAL_STATE__
const initialState = window.__INITIAL_STATE__ || {};

// Create the app with the same context and initial state as the server
const app = (
  <HelmetProvider>
    <BrowserRouter>
      <App metaTags={initialState.metaTags || {}} />
    </BrowserRouter>
  </HelmetProvider>
);

// Use hydrateRoot for SSR
try {
  hydrateRoot(rootElement, app);
  console.log('Hydration completed successfully');
} catch (error) {
  console.error('Hydration failed:', error);
  // In production, you might want to show a user-friendly error message
  throw error;
}